import gql from "graphql-tag";

export const SEND_CONTACT_EMAIL = gql`
    mutation sendContactEmail($msgBody: String!, $email: String!, $name: String!, $recaptchaToken: String!){
      sendContactEmail(msgBody: $msgBody, email: $email, name: $name, recaptchaToken: $recaptchaToken)
    }`


